import { createContext, useContext } from "react";

export interface MaintenanceModeContextType {
  isMaintenance: boolean | undefined;
  setIsMaintenance: (value: boolean) => void;
}

const MaintenanceModeContext = createContext<
  MaintenanceModeContextType | undefined
>(undefined);

const useMaintenanceModeContext = () => {
  const context = useContext(MaintenanceModeContext);

  if (context === undefined) {
    throw new Error(
      "useMaintenanceModeContext was used outside of its Provider",
    );
  }

  return context;
};

export { MaintenanceModeContext, useMaintenanceModeContext };
